export enum AttachmentTypeEnum {
  original = 'original',
  thumbnail = 'thumbnail',
}

export interface IMessageAttachment {
  fileName: string;
  filePath: string;
  types: Array<AttachmentTypeEnum>;
}

export interface IActionTimestamp {
  actionName: string;
  timestamp: string;
}

export interface IPatchMessagesReadBody {
  inquiryId?: string;
  messageSentTimestamps: Array<string>;
  messageSender: string;
}

export interface IPostMessagesBody {
  threadId: string;
  inquiryId: string;
  recipients: Array<string>;
  messageBody: string;
  attachments: Array<IMessageAttachment>;
  // threadName?: string; // FIXME: do we need it?
  serviceAttribute: number;
  serviceId: number;
}

export interface IPostMessagesBodyForNewInquiry {
  recipients: Array<string>;
  messageBody: string;
  attachments: Array<IMessageAttachment>;
  serviceId: number;
  serviceAttribute: number;
  categoryId: number;
  inquiryCategory: number;
  inquirySubCategory: number;
  targetName?: string;
  targetId?: string;
  targetUrl?: string;
}

export interface IGetMessagesParams {
  inquiryId?: string;
  minMessageSentTimestamp?: string;
  maxMessageSentTimestamp?: string;
  offset?: number;
  limit?: number;
}
export interface IGetMessagesResponse {
  threadId: string;
  inquiryId: string;
  messageBody: string;
  attachments: Array<IMessageAttachment>;
  messageSender: string;
  messageSentTimestamp: string;
  messageReadTimestamp: string | null;
  actionTimestamp: Array<IActionTimestamp>;
}
export interface IMessage {
  threadId: string;
  inquiryId: string;
  messageBody: string;
  attachments: Array<IMessageAttachment>;
  messageSender: string;
  messageSentTimestamp: string;
  messageReadTimestamp: string | null;
  actionTimestamp: Array<IActionTimestamp>;
}
